export interface BusinessInfo {
  channelPartnerId?: string;
  testCompany?: boolean;
  ela?: boolean;
}

export interface FeatureDetails {
  featureName: string;
  enabled: boolean;
  details?: string;
}

export enum BankInfoProvided {
  PROVIDED = 'PROVIDED',
  MISSING = 'MISSING',
  NOT_REQUIRED = 'NOT_REQUIRED',
}

export enum CompanyState {
  PENDING_ONBOARDING = 'PENDING_ONBOARDING',
}

export interface Company {
  homeChargingPartner: boolean;
  feePackageId?: string;
  id: string;
  currency: string;
  name: string;
  unit?: string;
  streetNumber?: string;
  street?: string;
  zipOrPostalCode?: string;
  city?: string;
  stateOrRegion?: string;
  isoCountryCode?: string;
  contactEmail?: string;
  contactPhone?: string;
  contactName?: string;
  transactionFeePercentage?: string;
  transactionFeeDollar?: string;
  driverSessionFee?: string;
  whiteLabellingId?: string;
  adminUserGroupId: string;
  noOfChargers?: number;
  noOfLocations?: number;
  virtualUserIds?: string[];
  defaultPriceModelId?: string;
  businessInfo?: BusinessInfo;
  bankInfoProvided?: BankInfoProvided;
  payterAccountIdentifier?: boolean;
  features: FeatureDetails[];
  showPaymentTerminalInfo?: boolean;
  hubSpotCompanyRecordId?: string;
  userPermissions?: string[];
  companyStateList?: (CompanyState.PENDING_ONBOARDING | null)[] | null;
  companyTaxId?: string;
}

export interface sendBankInfoReminderPayload {
  companyId: string;
  companyName: string;
}
